export default __webpack_public_path__ + "static/media/how-to-use-2.9db3baff.png";